import { useState, useEffect } from 'react';
import { User } from '@/lib/types';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(() => {
    if (typeof window !== 'undefined') {
      const storedUser = localStorage.getItem('user')
      if (storedUser) {
        try {
          return JSON.parse(storedUser)
        } catch {
          return null
        }
      }
    }
    return null
  })
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser.token) setUser(parsedUser);
      } catch {
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const getCityState = async () => {
    try {
      console.log('Getting city/state...');
      const traceResponse = await fetch('/cdn-cgi/trace');
      const traceData = await traceResponse.text();
      const ip = traceData.split('\n').find(line => line.startsWith('ip='))?.split('=')[1];
      console.log('IP found:', ip);

      if (!ip) throw new Error('IP not found');

      const locationResponse = await fetch(`https://ipapi.co/${ip}/json/`);
      const locationData = await locationResponse.json();
      console.log('Location API response:', locationData);

      if (!locationData.city || !locationData.region) {
        throw new Error('Location data incomplete');
      }

      return {
        cidade: locationData.city || 'undefined',
        estado: locationData.region || 'undefined'
      };
    } catch (error) {
      console.error('Error getting location:', error);
      throw error;
    }
  };

  const login = async (email: string, demographicsConsent: boolean) => {
    try {
      console.log('Consent status:', demographicsConsent);
      let locationData = {
        cidade: "undefined",
        estado: "undefined"
      };
      
      if (demographicsConsent) {
        try {
          locationData = await getCityState();
          console.log('Location data:', locationData);
        } catch (error) {
          console.error('Failed to get location data:', error);
          // Continue with undefined values if location fetch fails
        }
      }

      const requestBody = { 
        email,
        cidade: locationData.cidade,
        estado: locationData.estado
      };
      
      console.log('Request body:', requestBody);

      const response = await fetch('https://waffle-v2.theo-110.workers.dev/referrals/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.status === 'banned') {
          throw new Error('banned');
        }
        throw new Error('E-mail não encontrado');
      }
      const userData: User = { 
        email: data.subscriber_email,
        referrals_count: data.referrals_count, 
        referrer_id: data.referrer_id 
      };
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const subscribe = async (email: string, referrerId: string) => {
    try {
      // Capturar token da URL se disponível
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      
      // Preparar headers da requisição
      const headers: Record<string, string> = {
        'Content-Type': 'application/json'
      };
      
      // Adicionar token ao header Authorization se fornecido
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response: any = await fetch('https://waffle-v2.theo-110.workers.dev/referrals/subscribe', {
        method: 'POST',
        headers,
        body: JSON.stringify({
          referred_email: email,
          referrer_id: referrerId,
          campaign: 'launch'
        })
      });

      if (!response.ok) {
        if (response.message = 'Erro interno do servidor') {
          throw new Error('Desculpe, não foi possível completar seu cadastro no momento. Por favor, tente novamente mais tarde ou use outro e-mail.');
        } else if (response.message = 'Este email já está inscrito na newsletter.') {
          throw new Error('Esse e-mail aparenta já estar inscrito! Tente novamente ou use outro e-mail.')
        } else if (response.message = 'Referência fraudulenta encontrada.') {
          throw new Error('Esse e-mail não passou em nosso sistema anti-fraudes. Se considera isso um erro, envie o caso para: tech@waffle.com.br')
        }
        throw new Error('Desculpe, não foi possível completar seu cadastro no momento. Por favor, tente novamente mais tarde ou use outro e-mail.');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  };

  return { user, loading, login, logout, subscribe };
};